module.exports = __webpack_public_path__ + "static/media/high-school-locker.110daf20.png";